import { animate, style, transition, trigger } from '@angular/animations';
import { ANIMATION_DURATION } from '../../design-system/design-system.constants';

export const fadeOutAnimation = trigger('fadeOut', [
  transition(':leave', [animate(`${ANIMATION_DURATION}ms ease-in-out`, style({ opacity: 0 }))]),
]);
